export function fmtDate(d) {
  if (!d) return '—';
  const dt = new Date(d);
  if (isNaN(dt)) return d;
  return dt.toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function fmtCurrency(n) {
  if (n == null) return '—';
  return '₹' + Number(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
}

export function deadlineClass(dateStr) {
  if (!dateStr) return '';
  const today = new Date(); today.setHours(0,0,0,0);
  const d = new Date(dateStr); d.setHours(0,0,0,0);
  const diff = (d - today) / 86400000;
  if (diff < 0) return 'overdue';
  if (diff === 0) return 'due-today';
  if (diff <= 7) return 'due-soon';
  return '';
}

export function statusColor(status) {
  const map = {
    'Filed': 'bg-green-100 text-green-700',
    'Acknowledged': 'bg-green-100 text-green-700',
    'Done': 'bg-green-100 text-green-700',
    'Paid': 'bg-green-100 text-green-700',
    'Active': 'bg-green-100 text-green-700',
    'Completed': 'bg-green-100 text-green-700',
    'Data Pending': 'bg-red-100 text-red-700',
    'Pending': 'bg-red-100 text-red-700',
    'Overdue': 'bg-red-100 text-red-700',
    'Paid Late': 'bg-orange-100 text-orange-700',
    'Filed with Late Fee': 'bg-orange-100 text-orange-700',
    'Data Received': 'bg-blue-100 text-blue-700',
    'In Progress': 'bg-blue-100 text-blue-700',
    'Return Prepared': 'bg-blue-100 text-blue-700',
    'Computation Done': 'bg-blue-100 text-blue-700',
    'Reviewed': 'bg-purple-100 text-purple-700',
    'Review Pending': 'bg-purple-100 text-purple-700',
    'Partial': 'bg-yellow-100 text-yellow-700',
    'Sent': 'bg-yellow-100 text-yellow-700',
    'Draft': 'bg-gray-100 text-gray-700',
    'To Do': 'bg-gray-100 text-gray-600',
    'Received': 'bg-orange-100 text-orange-700',
    'Prospect': 'bg-yellow-100 text-yellow-700',
    'Inactive': 'bg-gray-100 text-gray-500',
    'Archived': 'bg-gray-200 text-gray-500',
    'Books Not Received': 'bg-red-100 text-red-700',
    'Books Received': 'bg-blue-100 text-blue-700',
    'In Progress': 'bg-blue-100 text-blue-700',
    'Completed': 'bg-green-100 text-green-700',
    'Sent to Client': 'bg-green-100 text-green-700',
    'Reconciled': 'bg-green-100 text-green-700',
    'Trial Balance': 'bg-yellow-100 text-yellow-700',
    'Adjustments': 'bg-orange-100 text-orange-700',
    'Draft P&L': 'bg-blue-100 text-blue-700',
    'Draft Balance Sheet': 'bg-blue-100 text-blue-700',
    'Final': 'bg-green-100 text-green-700',
    'Prepared': 'bg-blue-100 text-blue-700',
  };
  return map[status] || 'bg-gray-100 text-gray-600';
}

// Canonical client services list — the ONE source; import everywhere
export const CLIENT_SERVICES = ['IT Returns', 'TDS', 'GST', 'Audit', 'ROC', 'ESI', 'PF', 'Payroll', 'Accounts'];
export const FY_OPTIONS = ['2022-23','2023-24','2024-25','2025-26','2026-27','2027-28','2028-29','2029-30'];
export const AY_OPTIONS = ['AY 2023-24','AY 2024-25','AY 2025-26','AY 2026-27','AY 2027-28','AY 2028-29','AY 2029-30','AY 2030-31'];
export const CURRENT_FY = '2025-26';
export const CURRENT_AY = 'AY 2026-27';

// 4-tier RBAC roles (Feature 2). Legacy keys normalized for stale sessions.
const LEGACY_ROLE_MAP = { super_admin: 'partner', admin: 'senior_staff', article: 'junior_staff' };
export const normalizeRole = role => LEGACY_ROLE_MAP[role] || role;
export const ROLE_LABELS = {
  partner: 'Partner', senior_staff: 'Senior Staff',
  associate: 'Associate', junior_staff: 'Junior Staff',
};

export function hasRole(user, ...roles) {
  return user && roles.includes(normalizeRole(user.role));
}
// NOTE: these are coarse role fallbacks; per-module gating uses can() from
// useAuth(), backed by the editable role_permissions matrix
export function canSeeBilling(user) {
  return hasRole(user, 'partner', 'senior_staff', 'associate');
}
export function canDelete(user) {
  return hasRole(user, 'partner', 'senior_staff');
}
export function canImport(user) {
  return hasRole(user, 'partner', 'senior_staff');
}
export function canManageUsers(user) {
  return hasRole(user, 'partner', 'senior_staff');
}
export function isReadOnly(user) {
  return false;
}
export const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'];
export const MONTHS_FY = ['Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec','Jan','Feb','Mar'];
